import { makeStyles, mergeClasses } from '@fluentui/react-components';
import { tokens, typographyStyles } from '@fluentui-copilot/tokens';
import type { TimestampSlots, TimestampState } from './Timestamp.types';
import type { SlotClassNames } from '@fluentui/react-components';

export const timestampClassNames: SlotClassNames<TimestampSlots> = {
  root: 'fai-Timestamp',
};

/**
 * Styles for the root slot
 */
const useStyles = makeStyles({
  root: {
    color: tokens.colorNeutralForeground3,
    display: 'inline',
    textAlign: 'center',
    ...typographyStyles.caption1,
    margin: 0,
  },
});

/**
 * Apply styling to the Timestamp slots based on the state
 */
export const useTimestampStyles_unstable = (state: TimestampState): TimestampState => {
  'use no memo';

  const styles = useStyles();
  state.root.className = mergeClasses(timestampClassNames.root, styles.root, state.root.className);

  return state;
};
